import FeatureCTASection from "@/components/Features/FeatureCTASection";
import GraphyAssist from "@/components/Home/GraphyAssist";
import PlatformMigrationBanner from "@/components/Home/PlatformMigrationBanner";
import CtaBannerV2 from "@/components/Home/v2/CtaBannerV2";
import DarkAiBrainSection from "@/components/Home/v2/DarkAiBrainSection";
import FaqV2 from "@/components/Home/v2/FaqV2";
import FeaturePillMarquee from "@/components/Home/v2/FeaturePillMarquee";
import FooterV2 from "@/components/Home/v2/FooterV2";
import NavbarV2 from "@/components/Home/v2/NavbarV2";
import PlatformMigrationV2Section from "@/components/Home/v2/PlatformMigrationV2Section";
import PricingCoreFeaturesSection from "@/components/Home/v2/PricingCoreFeaturesSection";
import PricingHeroV2 from "@/components/Home/v2/PricingHeroV2";
import PricingPlansCompareSection from "@/components/Home/v2/PricingPlansCompareSection";
import StoriesMarqueeV2 from "@/components/Home/v2/StoriesMarqueeV2";
import { homeV2Data } from "@/shared/data/home.v2.data";
import { homeV2DataUs } from "@/shared/data/home.v2.data.us";
import { coursesStoriesSection } from "@/shared/data/product.v2.data";
import { buildUsStoriesFromFolder } from "@/shared/data/product.v2.data.us";
import {
  pricingV2AiBrainData,
  pricingV2CoreFeaturesData,
  pricingV2FaqData,
  pricingV2HeroData,
  pricingV2PlansData,
  pricingV2PlatformMigrationData,
} from "@/shared/data/pricing.v2.data";
import {
  pricingV2CoreFeaturesDataUs,
  pricingV2FaqDataUs,
  pricingV2HeroDataUs,
  pricingV2PlansDataUs,
} from "@/shared/data/pricing.v2.data.us";
import CommunityPlatformSection from "@/components/PricingPage/CommunityPlatformSection";
import FeatureHighlightBar from "@/components/PricingPage/FeatureHighlightBar";
import FeatureSection from "@/components/PricingPage/FeatureSection";
import PaidFeaturesSection from "@/components/PricingPage/PaidFeaturesSection";
import PricingComparisonNewEn from "@/components/PricingPage/PricingComparisonNewEn";
import PricingComparisonSection from "@/components/PricingPage/PricingComparisonSection";
import PricingHeroSection from "@/components/PricingPage/PricingHeroSection";
import PricingOfferingsSection, {
  PricingOfferingsSectionPropType,
} from "@/components/PricingPage/PricingOfferingsSection";
import TestimonyCarouselSectionPricing from "@/components/organisms/Carousels/TestimonyCarouselSectionPricing";
import FaqSection from "@/components/organisms/FaqSection";
import { FooterDataType } from "@/components/organisms/Footer";
import GraphyHead from "@/components/organisms/GraphyHead";
import { Navbar } from "@/components/organisms/Navbar";
import { DEFAULT_COUNTRY_CODE } from "@/shared/constants/common.constants";
import { creatorStoriesPageData_en, creatorStoriesPageData_us } from "@/shared/data/creator-stories.data";
import { creatorStoriesPageData_kr } from "@/shared/data/creator-stories.data.kr";
import { featurePagesData_en } from "@/shared/data/features.data";
import { featurePagesData_kr } from "@/shared/data/features.data.kr";
import { footerData_en, footerData_us } from "@/shared/data/footer.data";
import { footerData_kr } from "@/shared/data/footer.data.kr";
import { NavbarDataType, navbarData_en, navbarData_us } from "@/shared/data/navbar.data";
import { navbarData_kr } from "@/shared/data/navbar.data.kr";
import {
  PricingPageDataType,
  pricingPageData_en,
  pricingPageData_us,
} from "@/shared/data/pricing.data";
import { pricingPageData_kr } from "@/shared/data/pricing.data.kr";
import { productPagesData_en, productPagesData_us } from "@/shared/data/products.data";
import { productPagesData_kr } from "@/shared/data/products.data.kr";
import { useDataStore } from "@/shared/store/useDataStore";
import { useNavStore } from "@/shared/store/useNavStore";
import { SuccessStoryType } from "@/shared/types/common.types";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import dynamic from "next/dynamic";
import Head from "next/head";
import nookies from "nookies";
import { useEffect } from "react";

const Footer = dynamic(() => import("@/components/organisms/Footer"));

const coursesStoriesSectionUs = {
  ...coursesStoriesSection,
  stories: buildUsStoriesFromFolder(
    "Pricing Page/Pricing Page US images/Testimonial images"
  ),
};

export const getServerSideProps: GetServerSideProps<{
  locale: string;
  cookieCountryCode: string;
  cookieCurrencySymbol: string;
  pricingPageData: PricingPageDataType;
  pricingOfferingsSectionProps: PricingOfferingsSectionPropType;
  navbarData: NavbarDataType;
  footerData: FooterDataType;
}> = async (context) => {
  const pricingPageData = {
    en: pricingPageData_en,
    us: pricingPageData_us,
    kr: pricingPageData_kr,
    in: pricingPageData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const productPagesData = {
    en: productPagesData_en,
    us: productPagesData_us,
    kr: productPagesData_kr,
    in: productPagesData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const featurePagesData = {
    en: featurePagesData_en,
    us: featurePagesData_en,
    kr: featurePagesData_kr,
    in: featurePagesData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const creatorStoriesPageData = {
    en: creatorStoriesPageData_en,
    us: creatorStoriesPageData_en,
    kr: creatorStoriesPageData_kr,
    in: creatorStoriesPageData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const navbarData = {
    en: navbarData_en,
    us: navbarData_us,
    kr: navbarData_kr,
    in: navbarData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const footerData = {
    en: footerData_en,
    us: footerData_us,
    kr: footerData_kr,
    in: footerData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const { creatorStoriesHeroSectionProps } = creatorStoriesPageData;

  let filteredSuccessStories =
    creatorStoriesHeroSectionProps.successStories.filter(
      (successStory) => successStory.showOn.pricing
    );

  let updatedPricingPageData = {
    ...pricingPageData,
    pricingMarqueeSectionProps: pricingPageData.pricingMarqueeSectionProps
      ? {
          ...pricingPageData.pricingMarqueeSectionProps,
          successStories: filteredSuccessStories,
        }
      : null,
  };

  const pricingOfferingsSectionProps = {
    ...pricingPageData.pricingOfferingsSectionProps,
    productOfferings: productPagesData.map(
      (_productData) => _productData.otherOfferingsMeta
    ),
    featureOfferings: featurePagesData.map(
      (_featureData) => _featureData.otherOfferingsMeta
    ),
  };

  try {
    const cookies = nookies.get(context);

    const cookieCountryCode = cookies?.countryCode || DEFAULT_COUNTRY_CODE;
    const cookieCurrencySymbol = cookieCountryCode === "IN" ? "₹" : "$";

    return {
      props: {
        locale: context.locale ?? "en",
        cookieCountryCode,
        cookieCurrencySymbol,
        pricingPageData: updatedPricingPageData,
        pricingOfferingsSectionProps,
        navbarData,
        footerData,
      },
    };
  } catch (err) {
    return {
      props: {
        locale: context.locale ?? "en",
        cookieCountryCode: "",
        cookieCurrencySymbol: "",
        pricingPageData: updatedPricingPageData,
        pricingOfferingsSectionProps,
        navbarData,
        footerData,
      },
    };
  }
};

export default function Pricing({
  locale,
  cookieCountryCode,
  cookieCurrencySymbol,
  pricingPageData,
  pricingOfferingsSectionProps,
  navbarData,
  footerData,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const { countryCode, currencySymbol } = useDataStore();

  const { setShowSignUp } = useNavStore();

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (!scrollY) {
        setShowSignUp(true);
      } else {
        setShowSignUp(false);
      }
    });
    return () => {
      setShowSignUp(true);
    };
  }, []);

  // const pricingOfferingsSectionProps = {
  //   productOfferings: productPagesData_en.map(
  //     (_productData) => _productData.otherOfferingsMeta
  //   ),
  //   featureOfferings: featurePagesData_en.map(
  //     (_featureData) => _featureData.otherOfferingsMeta
  //   ),
  // };

  const finalCountryCode = countryCode || cookieCountryCode;
  const finalCurrencySymbol = currencySymbol || cookieCurrencySymbol;

  const isUsLocale = locale === "us";
  const activeHomeV2Data = isUsLocale ? homeV2DataUs : homeV2Data;
  const activePricingHeroData = isUsLocale ? pricingV2HeroDataUs : pricingV2HeroData;
  const activePricingPlansData = isUsLocale ? pricingV2PlansDataUs : pricingV2PlansData;
  const activePricingCoreFeaturesData = isUsLocale ? pricingV2CoreFeaturesDataUs : pricingV2CoreFeaturesData;
  const activePricingAiBrainData = pricingV2AiBrainData;
  const activePricingPlatformMigrationData = pricingV2PlatformMigrationData;
  const activePricingFaqData = isUsLocale ? pricingV2FaqDataUs : pricingV2FaqData;

  const {
    seoMeta,
    pricingHeroSectionProps,
    // estimationSectionProps,
    paidFeaturesSectionProps,
    communityPlatformSectionProps,
    pricingMarqueeSectionProps,
    faqSectionProps,
    featureCTASectionProps,
    scheduleDemoSectionProps,
    featuresSectionProps,
    planComparisonSectionProps,
    featureHighlightBar,
    graphyAssistSectionProps,
    platformMigrationBannerProps,
    reachOutPricingSectionProps,
    testimonySectionProps,
  } = pricingPageData;
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: activePricingFaqData.items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  }

  return (
    <>
      <GraphyHead {...seoMeta} countryCode={finalCountryCode} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      </Head>
      <div className="home-v2-scope relative">
        <NavbarV2 />
        <main className="relative z-10 flex flex-col">
          <PricingHeroV2 {...activePricingHeroData} />
          <FeaturePillMarquee
            items={[
              "Unlimited Products",
              "Unlimited Learners",
              "Branded Mobile Apps",
              "AI Avatars",
              "Secure Payments",
              "AI Website Builder",
            ]}
          />
          <PricingPlansCompareSection {...activePricingPlansData} />
          <PricingCoreFeaturesSection {...activePricingCoreFeaturesData} />
          <DarkAiBrainSection {...activePricingAiBrainData} />
          <StoriesMarqueeV2
            {...(isUsLocale ? coursesStoriesSectionUs : coursesStoriesSection)}
          />
          <PlatformMigrationV2Section {...activePricingPlatformMigrationData} />
          <FaqV2 {...activePricingFaqData} />
          <CtaBannerV2 {...activeHomeV2Data.ctaBanner} />
        </main>
        <FooterV2 {...activeHomeV2Data.footer} />
      </div>
      {/* Legacy sections retained below the V2 composition so existing
          pricing integrations (offerings, testimonies, CTA) continue to
          render. These can be removed once the V2 page has full parity. */}
      <div className="flex flex-col gap-12 sm:gap-20" style={{ display: "none" }}>
        {/* Highlight Bar */}
        {featureHighlightBar && (
          <FeatureHighlightBar   {...featureHighlightBar} />
        )}
        {/* Pricing Comparison Section: Both IN and US use new component */}
        {finalCountryCode === 'IN' ? (
          <PricingComparisonNewEn />
        ) : finalCountryCode === 'US' ? (
          <PricingComparisonNewEn countryCode="US" />
        ) : <PricingComparisonNewEn countryCode={finalCountryCode} />}
        {/* {scheduleDemoSectionProps && (
          <ScheduleCallSection {...scheduleDemoSectionProps} />
        )} */}
        {featuresSectionProps && <FeatureSection {...featuresSectionProps} />}
        {/* <EstimationSection
          {...estimationSectionProps}
          currencySymbol={finalCurrencySymbol}
          countryCode={finalCountryCode}
        /> */}
        {/* Render GraphyAssist section after features section, only on /pricing */}
        {graphyAssistSectionProps && (
          <GraphyAssist {...pricingPageData_en.graphyAssistSectionProps} />
        )}
        <TestimonyCarouselSectionPricing
          successStories={
            (finalCountryCode === 'IN'
              ? creatorStoriesPageData_en.creatorStoriesHeroSectionProps.successStories
              : creatorStoriesPageData_us.creatorStoriesHeroSectionProps.successStories
            ).filter((s: SuccessStoryType) => s.showOn?.pricing)
          }
          countryCode={finalCountryCode}
        />
        {paidFeaturesSectionProps && (
          <PaidFeaturesSection
            {...paidFeaturesSectionProps}
            countryCode={finalCountryCode}
          />
        )}
        {
          platformMigrationBannerProps && (
            <PlatformMigrationBanner {...platformMigrationBannerProps} />
          )
        }
        {communityPlatformSectionProps && (
          <CommunityPlatformSection {...communityPlatformSectionProps} />
        )}
        {/* {pricingMarqueeSectionProps && (
          <PricingMarqueeSection {...pricingMarqueeSectionProps} />
        )} */}
          {/* {
            reachOutPricingSectionProps && (
              <ReachOutPricingSection {...reachOutPricingSectionProps} />
            )
          } */}
        <FaqSection {...faqSectionProps} />
        <PricingOfferingsSection {...pricingOfferingsSectionProps} />
        <FeatureCTASection {...featureCTASectionProps} />
        <Footer footerData={footerData} />
      </div>
    </>
  );
}